import React, { useState } from "react";
import { Link } from "react-router-dom";
import { 
  FaTwitter, 
  FaLinkedin,
  FaCookieBite,
  FaTimes,
  FaToggleOn,
  FaToggleOff
} from "react-icons/fa";
import Logo from "./Logo";
import "./Footer.css";

function Footer() {
  const [showCookieModal, setShowCookieModal] = useState(false);
  const [cookieSettings, setCookieSettings] = useState({
    necessary: true,
    analytics: true,
    functional: true
  });

  const handleCookieToggle = (type) => {
    setCookieSettings(prev => ({
      ...prev,
      [type]: !prev[type]
    }));
  };

  const saveCookiePreferences = () => {
    localStorage.setItem('cookiePreferences', JSON.stringify(cookieSettings));
    setShowCookieModal(false);
  };

  return (
    <>
      {/* Creative Terminal-Style Footer */}
      <footer className="footer-v2">
        <div className="footer-terminal">
          {/* Terminal Header */}
          <div className="terminal-header-v2">
            <div className="terminal-dots">
              <span className="dot red"></span>
              <span className="dot yellow"></span>
              <span className="dot green"></span>
            </div>
            <span className="terminal-title">triagz@security:~</span>
            <div className="terminal-actions">
              <span className="status-badge">
                <span className="status-dot"></span>
                System Online
              </span>
            </div>
          </div>

          {/* Terminal Content */}
          <div className="terminal-content-v2">
            {/* Command Output Section */}
            <div className="footer-grid-v2">
              {/* Left Panel - About */}
              <div className="footer-panel main-panel">
                <div className="command-line">
                  <span className="prompt">$</span>
                  <span className="command">cat /about/triagz.md</span>
                </div>
                <div className="output-block">
                  <div className="footer-brand">
                    <Logo 
                      size="medium" 
                      showText={false} 
                      isClickable={false} 
                      className="footer-logo-v2" 
                      useFullLogo={true}
                    />
                  </div>
                  <p className="footer-desc">
                    Natural language endpoint research platform. 
                  </p>
                  <div className="social-bar">
                    <a href="https://x.com/triagzlab" target="_blank" rel="noopener noreferrer" className="social-chip">
                      <FaTwitter /> <span>@triagzlab</span>
                    </a>
                    <a href="https://www.linkedin.com/company/triagz" target="_blank" rel="noopener noreferrer" className="social-chip">
                      <FaLinkedin /> <span>LinkedIn</span>
                    </a>
                  </div>
                </div>
              </div>

              {/* Navigation Panels */}
              <div className="footer-panel nav-panel">
                <div className="command-line">
                  <span className="prompt">$</span>
                  <span className="command">ls ./product/</span>
                </div>
                <div className="output-block">
                  <ul className="nav-list">
                    <li>
                      <Link to="/downloads">
                        <span className="file-icon">📦</span>
                        <span className="file-name">agents</span>
                        <span className="file-type">.download</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/subscription">
                        <span className="file-icon">💎</span>
                        <span className="file-name">plans</span>
                        <span className="file-type">.pricing</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="footer-panel nav-panel">
                <div className="command-line">
                  <span className="prompt">$</span>
                  <span className="command">ls ./resources/</span>
                </div>
                <div className="output-block">
                  <ul className="nav-list">
                    <li>
                      <Link to="/blog">
                        <span className="file-icon">📝</span>
                        <span className="file-name">blog</span>
                        <span className="file-type">.posts</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blog/7">
                        <span className="file-icon">📚</span>
                        <span className="file-name">docs</span>
                        <span className="file-type">.wiki</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/report-bug">
                        <span className="file-icon">🐛</span>
                        <span className="file-name">bugs</span>
                        <span className="file-type">.report</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/add-suggestions">
                        <span className="file-icon">💡</span>
                        <span className="file-name">ideas</span>
                        <span className="file-type">.suggest</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="footer-panel nav-panel">
                <div className="command-line">
                  <span className="prompt">$</span>
                  <span className="command">ls ./company/</span>
                </div>
                <div className="output-block">
                  <ul className="nav-list">
                    <li>
                      <Link to="/our-vision">
                        <span className="file-icon">🎯</span>
                        <span className="file-name">vision</span>
                        <span className="file-type">.about</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/career">
                        <span className="file-icon">🚀</span>
                        <span className="file-name">careers</span>
                        <span className="file-type">.jobs</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact">
                        <span className="file-icon">✉️</span>
                        <span className="file-name">contact</span>
                        <span className="file-type">.us</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/donation">
                        <span className="file-icon">❤️</span>
                        <span className="file-name">support</span>
                        <span className="file-type">.donate</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Footer Bottom - Status Bar */}
            <div className="footer-status-bar">
              <div className="status-left">
                <span className="status-item">
                  <span className="prompt">©</span> 2025 triagz labs
                </span>
                <span className="status-divider">|</span>
                <span className="status-item clickable">
                  <Link to="/privacy-policy">privacy.policy</Link>
                </span>
                <span className="status-divider">|</span>
                <span className="status-item clickable">
                  <Link to="/terms-of-service">terms.service</Link>
                </span>
                <span className="status-divider">|</span>
                <button 
                  onClick={() => setShowCookieModal(true)} 
                  className="status-item clickable cookie-btn"
                >
                  cookies.manage
                </button>
              </div>
              <div className="status-right">
                <span className="version-tag">v1.0.1</span>
                <span className="uptime-badge">
                  <span className="pulse-dot"></span>
                  99.9% uptime
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Cookie Management Modal */}
      {showCookieModal && (
        <div className="cookie-modal-overlay">
          <div className="cookie-modal">
            <div className="cookie-modal-header">
              <div className="cookie-modal-title">
                <FaCookieBite className="cookie-icon" />
                <h3>Manage Cookies</h3>
              </div>
              <button 
                onClick={() => setShowCookieModal(false)}
                className="cookie-close-btn"
              >
                <FaTimes />
              </button>
            </div>
            
            <div className="cookie-modal-content">
              <p className="cookie-description">
                We use cookies to enhance your experience, analyze site traffic, and personalize content. 
                You can manage your preferences below.
              </p>
              
              <div className="cookie-categories">
                <div className="cookie-category">
                  <div className="cookie-category-header">
                    <div className="cookie-category-info">
                      <h4>Necessary Cookies</h4>
                      <p>Essential for the website to function properly. Cannot be disabled.</p>
                    </div>
                    <div className="cookie-toggle disabled">
                      <FaToggleOn />
                    </div>
                  </div>
                </div>
                
                <div className="cookie-category">
                  <div className="cookie-category-header">
                    <div className="cookie-category-info">
                      <h4>Analytics Cookies</h4>
                      <p>Help us understand how visitors interact with our website.</p>
                    </div>
                    <button 
                      className="cookie-toggle"
                      onClick={() => handleCookieToggle('analytics')}
                    >
                      {cookieSettings.analytics ? <FaToggleOn /> : <FaToggleOff />}
                    </button>
                  </div>
                </div>
                
                <div className="cookie-category">
                  <div className="cookie-category-header">
                    <div className="cookie-category-info">
                      <h4>Functional Cookies</h4>
                      <p>Enable enhanced functionality and personalization.</p>
                    </div>
                    <button 
                      className="cookie-toggle"
                      onClick={() => handleCookieToggle('functional')}
                    >
                      {cookieSettings.functional ? <FaToggleOn /> : <FaToggleOff />}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="cookie-modal-footer">
              <button 
                onClick={() => setShowCookieModal(false)}
                className="cookie-btn-secondary"
              >
                Cancel
              </button>
              <button 
                onClick={saveCookiePreferences}
                className="cookie-btn-primary"
              >
                Save Preferences
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Footer;

